import React, { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { LoginDto, OsbukNetLoginDto } from "../../services/auth/auth.dto";
import authService from "../../services/auth/auth.service";
import { useAuth } from "../../utils/auth";
import { useToast } from "../../utils/toast";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";

const LoginSebis = () => {
  const auth = useAuth();
  const toast = useToast();
  const [checked, setChecked] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const navigate = useNavigate();

  const sebisLoginFormik = useFormik<LoginDto>({
    initialValues: {
      email: "",
      password: ""
    },
    enableReinitialize: true,
    validate: (data) => {
      const errors: any = {};

      if (!data.email) {
        errors.email = "E-Posta gereklidir";
      }

      if (!data.password) {
        errors.password = "Şifre gereklidir";
      }

      return errors;
    },
    onSubmit: async (values) => {
      try {
        if (checked) {
          const formData: OsbukNetLoginDto = {
            email: sebisLoginFormik.values.email,
            password: sebisLoginFormik.values.password
          };

          const response = await authService.OsbukLogin(formData);

          if (response.result && response.result.statusCode === 200) {
            const res = await authService.CreateTokenOsb(values);
            if (res.result && !res.result.error) {
              auth.removeUserFromStorage();
              auth.setToken(res.result.data, true);
              navigate("/app/homepage", { replace: true });
            } else {
              toast.show(res?.result?.error || "Giriş işlemi başarısız oldu", "error");
            }
          } else {
            if (response.result && response.result.statusCode === 400) {
              toast.show("Osbuk.net " + response.result.error || "Osbuk.net Giriş işlemi başarısız oldu", "error");
            } else {
              toast.show("Osbuk.net girişi başarısız, lütfen bilgilerinizi kontrol edin", "error");
            }
          }
        } else {
          const res = await authService.CreateToken(values);
          if (res.result && !res.result.error) {
            auth.removeUserFromStorage();
            auth.setToken(res.result.data, true);
            navigate("/app/homepage", { replace: true });
          } else {
            toast.show(res?.result?.error || "Giriş işlemi başarısız oldu", "error");
          }
        }
      } catch (error) {
        console.error("Login request failed:", error);
        toast.show("Beklenmeyen bir hata oluştu, lütfen tekrar deneyin", "error");
      }
    }
  });

  return (
    <div className="grid grid-nogutter min-h-screen surface-ground">
      <div
        className="col-12 xl:col-6 flex justify-content-center align-items-center min-h-screen py-5 px-3 sm:px-6"
      >
        <form
          key="sebis-login-form"
          className="w-full max-w-30rem"
          onSubmit={sebisLoginFormik.handleSubmit}
          style={{ maxWidth: "460px" }}
        >
          <div className="surface-card border-1 surface-border border-round-2xl shadow-3 p-4 sm:p-5 md:p-6">
            <div className="text-center mb-5">
              <Link to="/">
                <img src="/images/logoosbuk.png" alt="OSBÜK Logo" height="48" className="mb-3" />
              </Link>
              <div className="text-900 text-2xl sm:text-3xl font-bold mb-2">SEBİS Giriş</div>
              <span className="text-600 text-sm sm:text-base">Hesabınız ile sisteme giriş yapınız</span>
            </div>

            <div>
              <div className="mb-4">
                <label htmlFor="email" className="block text-900 font-medium mb-2">
                  E-Posta Adresi
                </label>
                <InputText
                  id="email"
                  type="email"
                  placeholder="E-postanızı giriniz"
                  className="w-full p-3"
                  value={sebisLoginFormik.values.email}
                  onChange={(e) => sebisLoginFormik.setFieldValue("email", e.target.value)}
                />
                {sebisLoginFormik.errors.email && (
                  <div className="p-error mt-2 text-sm">{sebisLoginFormik.errors.email}</div>
                )}
              </div>

              <div className="mb-4">
                <div className="flex align-items-center justify-content-between mb-2">
                  <label htmlFor="password" className="block text-900 font-medium">
                    Şifre
                  </label>
                  <Link
                    to="/forgot-password"
                    className="font-medium text-xs sm:text-sm text-primary cursor-pointer hover:underline"
                  >
                    Şifremi Unuttum
                  </Link>
                </div>
                <div className="relative w-full">
                  <InputText
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={sebisLoginFormik.values.password}
                    onChange={(e) => sebisLoginFormik.setFieldValue("password", e.target.value)}
                    placeholder="Şifrenizi giriniz"
                    className="w-full p-3 pr-6"
                  />
                  <i
                    className={`pi ${showPassword ? "pi-eye-slash" : "pi-eye"} cursor-pointer text-600 hover:text-900 absolute`}
                    style={{ right: "1rem", top: "50%", transform: "translateY(-50%)", fontSize: "1.2rem", zIndex: 10 }}
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                  />
                  {sebisLoginFormik.errors.password && (
                    <div className="p-error mt-2 text-sm">{sebisLoginFormik.errors.password}</div>
                  )}
                </div>
              </div>

              <div className="flex align-items-center justify-content-center my-4 gap-2">
                <InputSwitch
                  id="osbukSwitch"
                  checked={checked}
                  onChange={(e: InputSwitchChangeEvent) => setChecked(e.value)}
                />
                <label htmlFor="osbukSwitch" className="text-sm text-700 cursor-pointer user-select-none">
                  Osbuk.net hesabı ile oturum aç
                </label>
              </div>

              <div>
                <Button label="Giriş Yap" className="w-full p-3 text-lg font-semibold" type="submit" />

                <div className="w-full mt-4 text-center">
                  <span className="text-600 text-sm">Hesabınız yok mu? </span>
                  <Link
                    to="/register"
                    className="font-semibold text-sm text-primary cursor-pointer hover:underline ml-1"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="col-6 hidden xl:block relative overflow-hidden" style={{ maxHeight: "100vh" }}>
        <img
          src="/images/login.jpg"
          alt="Login"
          className="w-full h-full"
          style={{ objectFit: "cover" }}
        />
      </div>
    </div>
  );
};

export default LoginSebis;
